import { useEffect } from "react";
import TagManager from "react-gtm-module";
import SEO from "../SEO";
import styles from "./Comparison.module.css";

const DISCLAIMER =
  "שמות המותגים המוזכרים הם קניינם של בעליהם ומובאים לצורך השוואה והמחשה בלבד.";

// Columns: technology/product brands available in Israel. Falcon = ours.
const brands = ["Falcon (Waterless)", "URIMAT", "URIDAN", "VELTIA", "Green-P"];

// rows[i] = { label, cells: [falcon, urimat, uridan, veltia, greenp] }  /* VERIFY all cells */
const rows = [
  { label: "ארץ מקור", cells: ["בריטניה", "שוויץ", "אוסטריה", "ספרד", "ישראל"] /* VERIFY */ },
  { label: "טכנולוגיית חסימת ריח", cells: ["מחסנית Falcon Velocity", "מערכת מיקרוביולוגית", "נוזל איטום (שמן)", "שסתום אל-חוזר", "פילטר ונוזל חוסם"] /* VERIFY */ },
  { label: "צריכת מים", cells: ["0 ליטר", "0 ליטר", "0 ליטר", "0 ליטר", "0 ליטר"] },
  { label: "חשמל / חיישנים", cells: ["לא נדרש", "לא נדרש", "לא נדרש", "לא נדרש", "לא נדרש"] /* VERIFY */ },
  { label: "כשר לשבת", cells: ["כן", "—", "—", "—", "—"] /* VERIFY */ },
  { label: "יבואן ושירות מקומי בישראל", cells: ["כן — שירות ואחריות ארצית", "—", "—", "—", "—"] /* VERIFY */ },
];

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "השוואת משתנות ללא מים — Falcon מול URIMAT, URIDAN, VELTIA ו-Green-P",
  description:
    "השוואה עניינית בין טכנולוגיות משתנות ללא מים הזמינות בישראל: Falcon, URIMAT, URIDAN, VELTIA ו-Green-P, לפי טכנולוגיה, חיסכון ושירות.",
  url: "https://waterless.co.il/השוואת-משתנות-ללא-מים",
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "דף הבית", item: "https://waterless.co.il/" },
    {
      "@type": "ListItem",
      position: 2,
      name: "השוואת משתנות ללא מים",
      item: "https://waterless.co.il/השוואת-משתנות-ללא-מים",
    },
  ],
};

function Comparison() {
  useEffect(() => {
    window.scrollTo(0, 0);
    TagManager.dataLayer({
      dataLayer: { event: "pageview", pagePath: "/השוואת-משתנות-ללא-מים", pageTitle: "השוואת משתנות ללא מים" },
    });
  }, []);

  return (
    <main className={`container px-3 px-md-5 ${styles.page}`}>
      <SEO
        title="השוואת משתנות ללא מים בישראל — Falcon מול URIMAT, URIDAN | ווטרלס (Waterless)"
        description="השוואה עניינית בין טכנולוגיות משתנות ללא מים בישראל: Falcon, URIMAT, URIDAN, VELTIA ו-Green-P — לפי טכנולוגיית חסימת ריח, חיסכון במים, כשרות לשבת ושירות מקומי."
        path="/השוואת-משתנות-ללא-מים"
        structuredData={[webPageSchema, breadcrumbSchema]}
      />
      <h1 className={styles.title}>השוואת משתנות ללא מים בישראל</h1>
      <p className={styles.lead}>
        בשוק הישראלי קיימות כמה טכנולוגיות של משתנות ללא מים. כדי לעזור לכם לבחור נכון, ריכזנו השוואה
        עניינית בין המותגים המובילים — Falcon (שאותו מייבאת Waterless), URIMAT, URIDAN, VELTIA ו-Green-P
        — לפי הפרמטרים שחשובים באמת לעסק. כל המשתנות חוסכות מים, אך הן נבדלות בטכנולוגיית חסימת הריח,
        בתחזוקה ובזמינות שירות מקומי בישראל.
      </p>

      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <caption className="visually-hidden">השוואת מותגי משתנות ללא מים</caption>
          <thead>
            <tr>
              <th scope="col">פרמטר</th>
              {brands.map((b, i) => (
                <th scope="col" key={b} className={i === 0 ? styles.ours : undefined}>{b}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.label}>
                <th scope="row">{row.label}</th>
                {row.cells.map((c, i) => (
                  <td key={`${row.label}-${i}`} className={i === 0 ? styles.ours : undefined}>{c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className={styles.lead}>
        השורה התחתונה: כל המשתנות חוסכות מים, אך Falcon מציעה שילוב של טכנולוגיית מחסנית מוכחת, תחזוקה
        פשוטה, כשרות לשבת ושירות ואחריות מקומיים מלאים בישראל דרך Waterless. זה ההבדל בין מוצר טוב לבין
        פתרון שמלווה אתכם לאורך שנים.
      </p>

      <p className={styles.disclaimer}>{DISCLAIMER}</p>

      <a className={styles.cta} href="/contact" aria-label="קבל הצעת מחיר למשתנות ללא מים">
        קבל הצעת מחיר מ-Waterless
      </a>
    </main>
  );
}

export default Comparison;
